import React, {Component, createRef} from "react";
import styles from './FJVideoSearchView.module.less';
import classNames from 'classnames';
import FJVideoItem from "./FJVideoItem";
import FJLayout from 'fj-components/FJLayout';
import FJUtil from "../../../../../util/FJUtil";
import FJLocalStore from "../../../../../store/FJLocalStore";
import FJSearchCommonView from "../FJSearchCommonView";

class FJVideoSearchView extends Component {

  constructor(props) {
    super(props);
    this.layout = createRef();
    this.timer = null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {active} = this.props;
    if (prevProps.active !== active && active) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.layout.current && this.layout.current.updateUI();
      }, 300);
    }
  }

  render() {

		let {
			active,
			collections,
			onSearch,
			total,
			searchKeyword,
			onPreview,
			onSubmit,
			slectedIds,
			searchStatus,
			searchNextPage,
			onRetry,
		} = this.props;

		const basicWidth = 360;

		return (
			<div className={classNames(styles.video_search_container, {[styles.active]: active})}>
				<FJSearchCommonView keywords={searchKeyword}
				                    onRetry={onRetry}
				                    status={searchStatus}
				                    searchNextPage={searchNextPage}
				                    className={styles.search_view}
                            info={{total, type: FJLocalStore._('videos')}}
				                    renderList={() => {
					                    return (
						                    <div className={styles.content}>
							                    <FJLayout basicWidth={basicWidth}
                                            ref={this.layout}
							                              className={styles.layout}
							                              space={0}
							                              render={(itemWidth) => {
								                              let items = [];
								                              let itemHeight = itemWidth / 16 * 9 + 15;
								                              collections.map(item => {
									                              const {
										                              id,
										                              title,
										                              duration,
										                              download_format_details,
										                              keywords,
										                              preview_url,
										                              thumbnail_url
									                              } = item;
									                              return items.push(
										                              <FJVideoItem key={id}
										                                           id={id}
										                                           selected={slectedIds.includes(id)}
										                                           format={FJUtil.getFormat(download_format_details)}
										                                           keywords={keywords}
										                                           duration={duration}
										                                           info={title}
										                                           thumbnail={thumbnail_url}
										                                           onSearch={onSearch}
										                                           width={itemWidth}
										                                           height={itemHeight}
										                                           videoUrl={preview_url}
										                                           onSubmit={onSubmit}
										                                           onPreview={onPreview}
										                              />
									                              )
								                              })
								                              return items;
							                              }}/>
						                    </div>
					                    );
				                    }}/>
			</div>
		)
	}
}


export default FJVideoSearchView;